export default __webpack_public_path__ + "static/paypal-complete-transaction-as-guest-v5-aeecc84a0db15484179da39742083e9c.jpg";